import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private authService:AuthService,private route:Router){

  }
  canActivate(){
    // console.log(this.authService.isLoggedIn());
    if(this.authService.isLoggedIn()){
      // console.log(this.authService.isLoggedIn());
      return true;
    }else{
      this.route.navigate(['auth/login'])
      return false;
    }
  }
  
}
